import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { getLanguageCode } from "@alipay/rewards-common-tools/index";
var stringConfig = {
  zh: {
    defaultErrorTips: "系統繁忙，請刷新重試",
    inventoryShoreageTitle: "哎呀！來太晚啦，券已經被其他人領取了！",
    inventoryShoreageSubtitle: "",
    okText: "好的",
    refreshText: "刷新一下",
    landingText: "landing..."
  },
  en: {
    defaultErrorTips: "Something went wrong...Please try again later.",
    inventoryShoreageTitle: "Too late! All the vouchers have all been claimed...",
    inventoryShoreageSubtitle: "Come earlier next time!",
    okText: "Ok",
    refreshText: "Refresh",
    landingText: "Loading..."
  },
  th: {
    defaultErrorTips: "มีผิดพลาดเกิดขึ้น...กรุณาลองใหม่อีกครั้งในภายหลัง.",
    inventoryShoreageTitle: "อ๊ะ! มาช้าอดแล้ว คนอื่นรับคูปองไปหมดแล้ว!",
    inventoryShoreageSubtitle: "",
    okText: "โอเค",
    refreshText: "รีเฟรช",
    landingText: "กำลังโหลดอยู่"
  },
  in: {
    defaultErrorTips: "Ada yang salah...Coba lagi nanti.",
    inventoryShoreageTitle: "Sayang sekali! Semua voucher sudah diklaim...",
    inventoryShoreageSubtitle: "Datanglah lebih awal lain kali!",
    okText: "Oke",
    refreshText: "Muat Ulang",
    landingText: "Memuat...."
  },
  ko: {
    defaultErrorTips: "오류가 발생하였습니다, 잠시 후 다시 시도해 주세요.",
    inventoryShoreageTitle: "아쉬워요！쿠폰이 모두 소진되었습니다.",
    inventoryShoreageSubtitle: "",
    okText: "확인",
    refreshText: "새로고침",
    landingText: "로딩 중"
  }
};
export var getDefaultString = function getDefaultString(string) {
  var _stringConfig$lang;
  var _getLanguageCode$spli = getLanguageCode().split("_"),
    _getLanguageCode$spli2 = _slicedToArray(_getLanguageCode$spli, 1),
    lang = _getLanguageCode$spli2[0];
  return (stringConfig === null || stringConfig === void 0 ? void 0 : (_stringConfig$lang = stringConfig[lang]) === null || _stringConfig$lang === void 0 ? void 0 : _stringConfig$lang[string]) || "";
};
